import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import PremiumWelcomeOverlay from './PremiumWelcomePage';

// Smart API URL switching
const API_BASE_URL =
    window.location.hostname === "staging187611.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : window.location.hostname === "digassistant.xyz" || window.location.hostname === "www.digassistant.xyz"
        ? "https://api.digassistant.xyz"
        : "http://localhost:8080";

const PremiumDropdown = ({ onShowDiveHistory, GuideComponent }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [showGuide, setShowGuide] = useState(false);
    const navigate = useNavigate();
    const Guide = GuideComponent || PremiumWelcomeOverlay;

    const fetchSubscriptionStatus = async () => {
        try {
            const response = await fetch(`${API_BASE_URL}/auth/check`, {
                credentials: "include",
            });

            if (response.ok) {
                // const data = await response.json();
                // console.log('🔍 PremiumDropdown: Auth check response:', data);
                // Check if subscription is cancelled at period end (from JWT token)
                // const isCancelled = data.cancelAtPeriodEnd || false;
                // console.log('🔍 PremiumDropdown: cancelAtPeriodEnd =', isCancelled);
            } else {
                // console.log('❌ PremiumDropdown: Auth check failed, defaulting to active');
            }
        } catch (error) {
            console.error("Error fetching subscription status:", error);
        }
    };

    const handleLogout = async () => {
        try {
            await fetch(`${API_BASE_URL}/auth/google/logout`, {
                method: "POST",
                credentials: "include",
            });
        } catch (error) {
            console.error("Logout error:", error);
        }
        localStorage.removeItem("welcomeShown"); // Reset welcome overlay on logout
        localStorage.removeItem("premiumWelcomeShown"); // Reset premium welcome overlay on logout
        navigate("/");
    };

    const handleManageSubscription = () => {
        navigate("/manage/membership");
    };

    const handleSupport = () => {
        navigate("/support");
    };

    const handleInfo = () => {
        navigate("/info");
    };

    return (
        <div className="premium-dropdown">
            {showGuide && <Guide onClose={() => setShowGuide(false)} />}
            {/* Burger Menu Button */}
            <button
                className="burger-menu-button"
                onClick={() => {
                    setIsOpen(!isOpen);
                    // Refresh subscription status when opening dropdown
                    if (!isOpen) {
                        fetchSubscriptionStatus();
                    }
                }}
                aria-label="Menu"
            >
                <div className={`burger-line ${isOpen ? 'open' : ''}`}></div>
                <div className={`burger-line ${isOpen ? 'open' : ''}`}></div>
                <div className={`burger-line ${isOpen ? 'open' : ''}`}></div>
            </button>

            {/* Dropdown Menu */}
            {isOpen && (
                <div className="dropdown-menu">
                    <button
                        onClick={handleLogout}
                        className="dropdown-item"
                    >
                        Logout
                    </button>
                    <button
                        onClick={handleManageSubscription}
                        className="dropdown-item cancel-subscription"
                    >
                        Manage Membership
                    </button>
                    <button
                        onClick={handleInfo}
                        className="dropdown-item"
                    >
                        Info
                    </button>
                    {GuideComponent && (
                        <button
                            onClick={() => { setShowGuide(true); setIsOpen(false); }}
                            className="dropdown-item"
                        >
                            How to use voyage mode
                        </button>
                    )}
                    <button
                        onClick={handleSupport}
                        className="dropdown-item"
                    >
                        Contact
                    </button>
                </div>
            )}
        </div>
    );
};

export default PremiumDropdown;
